<div class="learnsets-list">
  <ng-container *ngFor="let learnset of learnsets; let last = last">
    <div class="learnset-row" (click)="handleLearnsetClick(learnset)">
      <span class="name">{{learnset.name}}</span>
      
      <div *ngIf="allowActions" class="actions-container">
        <i-tabler name="pencil" class="action-icon" (click)="editLearnset($event, learnset)"></i-tabler>
        <i-tabler name="trash" class="action-icon delete-icon" (click)="deleteLearnset($event, learnset)"></i-tabler>
      </div>

      <div *ngIf="learnset.smartRepetitionEnabled && learnset.openCards > 0" class="open-cards">
        <i class="fas fa-repeat"></i>
        <span>{{learnset.openCards}}</span>
      </div>
      
      <i-tabler name="chevron-right"></i-tabler>
    </div>
    <div *ngIf="!last" class="divider"></div>
  </ng-container>
</div>

<app-bottom-dialog [isVisible]="editLearnsetVisible" [title]="'Lernset bearbeiten'" (close)="editLearnsetVisible = false" (actionCancelled)="editLearnsetVisible = false">
  <app-edit-learnset [learnset]="learnsetToEdit" (actionFinished)="editLearnsetVisible = false"></app-edit-learnset>
</app-bottom-dialog>